import freeEmailList from "../free-email-list.json";
import { getPDCookie } from "./cookies";
import {
  trialFormNextButtonClicked,
  trialFormElementUserInputDetected,
} from "../segment-tracks.js";
import { isPdEmployee } from "./pd-helpers";

/**
 * @typedef {{turnstileResponseError?: boolean, turnstileValueMissing?: boolean}} TurnstileValidityState
 * @typedef {
 (keyof(ValidityState) & {blockedEmailTld?: boolean}) |
 {domainTaken?: boolean} |
 {tooLong?: boolean} |
 TurnstileValidityState
 } CustomValidityState
 */

const employeeSearchCriteria = ["Email-hero"];

export function mkwid() {
  return getPDCookie("mkwid");
}
export function gclid() {
  return getPDCookie("gclid");
}

/** @arg {HTMLElement} root */
export function hideIndividualErrors(root) {
  for (const elm of Array.from(root.children)) {
    if (elm instanceof HTMLElement) elm.classList.add("hidden");
  }
}

/**
 * @arg {HTMLElement} root
 * @arg {CustomValidityState} validity
 */
export function showSpecificError(root, validity) {
  for (const error in validity) {
    if (validity[/** @type {keyof(CustomValidityState)} */ (error)]) {
      const elms = root.querySelectorAll(`.${error}`);
      for (const elm of Array.from(elms)) {
        if (elm instanceof HTMLElement) elm.classList.remove("hidden");
      }
    }
  }
}

/**
 * @arg {string} email
 */
export function isBlockedEmailTld(email) {
  return freeEmailList.some((it) => email.includes(it));
}

/**
 * @arg  {HTMLInputElement} email
 */
export function checkEmailValidity(email) {
  return email.checkValidity() && !isBlockedEmailTld(email.value);
}

/**
 * @arg  {HTMLInputElement} email
 */
export function getEmailValidity(email) {
  const emailValidity = email.validity;
  const validity = { blockedEmailTld: isBlockedEmailTld(email.value) };
  for (const key in emailValidity) {
    // @ts-expect-error
    validity[key] = emailValidity[key];
  }
  return /** @type {CustomValidityState} */ (validity);
}

/**
 * @param {boolean} userEmailTracker
 */
export function sendUserInputTrack(userEmailTracker) {
  const tracks = {};
  tracks.form_type = "Single Line Form";
  tracks.version = "2.0";
  tracks.field_name = "email";
  tracks.organism = "hero";
  tracks.is_pd_employee = isPdEmployee(employeeSearchCriteria);

  if (userEmailTracker === false) {
    trialFormElementUserInputDetected(tracks);
    userEmailTracker = true;
  }
  return userEmailTracker;
}

export function isValidEmail() {
  const email = document.getElementById("Email-hero");
  const isValid = checkEmailValidity(/** @type HTMLInputElement */ (email));
  const root = document.getElementById("email-errors");
  if (root) {
    root.classList[isValid ? "add" : "remove"]("hidden");
    if (!isValid) {
      hideIndividualErrors(root);
      showSpecificError(
        root,
        getEmailValidity(/** @type HTMLInputElement */ (email)),
      );
    }
  }
  return isValid;
}

/**
 * @arg {boolean} isValid
 */
export function trackEmailStep(isValid) {
  const step_name = "email";
  const errorIcon = document.getElementById("email-error-icon");
  if (isValid) errorIcon?.classList.add("hidden");
  else errorIcon?.classList.remove("hidden");
  var tracks = {
    form_type: "Single Line Form",
    version: "3",
    step_number: 1,
    step_name: step_name,
    step_status: isValid ? "success" : "failed",
    failure_type: isValid ? "N/A" : "Validation failure",
    error_message: isValid ? "N/A" : "failed validating " + step_name,
    organism: "hero",
    is_pd_employee: isPdEmployee(employeeSearchCriteria),
    mkwid: mkwid(),
    gclid: gclid(),
  };
  trialFormNextButtonClicked(
    /** @type {import('../segment-tracks').SlfOptions} */ (tracks),
  );
}
